import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { StepIndicatorModel } from './stepindicator.model';

@Injectable()
export class StepIndicatorService {
  private step = new BehaviorSubject<string>('billing');
  public obvStep: Observable<string> = this.step.asObservable(); // convert to Observable for subscribing
  private flag = new BehaviorSubject<boolean>(true);
  public showFlag: Observable<boolean> = this.flag.asObservable();

  constructor() {
  }
  setCurrentStep(path: string) {
    this.step.next(path);
  }
  getCurrentStep(): Observable<string> {
    return this.obvStep;
  }
  setSteps(steps: StepIndicatorModel[], sessionName) {
    sessionStorage.setItem('steps-' + sessionName, JSON.stringify(steps));
  }
  getSteps(sessionName): StepIndicatorModel[] {
    return JSON.parse(sessionStorage.getItem('steps-' + sessionName));
  }
  setVisibility(value: boolean) {
    this.flag.next(value);
  }
  getVisibility(): Observable<boolean> {
    return this.showFlag;
  }
  removeStep(sessionName) {
    sessionStorage.removeItem('steps-' + sessionName);
  }
}
